/**
 * leadform_ink1 — 하단 mbar 「관심고객 등록」 → 같은 폼(LeadForm 1벌)을 바텀시트로 연다.
 *
 * ⚠️ 폼 인스턴스는 페이지에 «하나» 다(CL14 · DS_RULES#5). 시트는 새 폼이 아니라
 *    그 한 벌이 «자리를 옮겨» 그려지는 것이다 — 열기 요청은 이 이벤트로만 보낸다.
 * ⚠️ 듣는 폼이 없으면(폼이 없는 화면 · 하이드레이션 전) false 를 돌려준다 —
 *    호출부는 종전처럼 #lead-form 앵커로 이동한다(JS 꺼짐 = <a href="#lead-form"> 기본 동작).
 */
export const LEAD_SHEET_EVENT = 'kd:lead-sheet-open';

export interface LeadSheetOpenDetail { slot: string }

/** 시트 열기 요청. 폼이 받아 열었으면 true. */
export function openLeadSheet(slot: string): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const ev = new CustomEvent<LeadSheetOpenDetail>(LEAD_SHEET_EVENT, { cancelable: true, detail: { slot } });
    // 듣는 폼이 preventDefault 로 «받았다» 를 알린다 → dispatchEvent 가 false.
    return !window.dispatchEvent(ev);
  } catch {
    return false;
  }
}
